(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (factory((global.eventbeat = {})));
}(this, (function (exports) { 'use strict';

  function clone(target, source) {
    var obj = {};

    for (var i in target) obj[i] = target[i];
    for (var i in source) obj[i] = source[i];

    return obj
  }

  function applyToAction(dispatch) {
    var actionsOfType = {};
    var oldSubs = [];

    return function(subs) {
      for (var i = 0; i < subs.length || i < oldSubs.length; i++) {
        oldSubs[i] = patch(subs[i], oldSubs[i]);
      }
    }

    function eventListener(data) {
      for (var i = 0, a = actionsOfType[data.type]; i < a.length; i++) {
        dispatch(a[i](data));
      }
    }

    function bindToDispatch(action) {
      return function(data) {
        dispatch(action(data));
      }
    }

    function render(sub) {
      return clone(sub, {
        unsubscribe: sub.subscribe(sub, bindToDispatch(sub.action))
      })
    }

    function start(sub) {
      if (sub.type) {
        actionsOfType[sub.type] = (actionsOfType[sub.type] || []).concat(
          sub.action
        );
        addEventListener(sub.type, eventListener);
        return sub
      }
      return render(sub)
    }

    function update(sub, oldSub) {
      for (var k in clone(sub, oldSub)) {
        if (k !== "unsubscribe" && sub[k] !== oldSub[k]) {
          if (sub.type) {
            actionsOfType[oldSub.type] = actionsOfType[oldSub.type].map(function(
              action
            ) {
              return action === oldSub.action ? sub.action : action
            });
            return sub
          }

          oldSub.unsubscribe();
          return render(sub)
        }
      }
      return oldSub
    }

    function remove(sub) {
      if (sub.type) {
        actionsOfType[sub.type] = actionsOfType[sub.type].filter(function(
          action
        ) {
          return action !== sub.action
        });

        if (!actionsOfType[sub.type].length) {
          removeEventListener(sub.type, eventListener);
        }
      } else {
        sub.unsubscribe();
      }
    }

    function patch(sub, oldSub) {
      return sub
        ? oldSub
          ? update(sub, oldSub)
          : start(sub)
        : oldSub
          ? remove(oldSub)
          : oldSub
    }
  }

  exports.applyToAction = applyToAction;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
